// src/components/QuotaBar.js
import React, { useState } from "react";

export default function QuotaBar({ totalBillets, isPro, STARTER_LIMIT, onUpgrade, loadingPaiement, peutPayer = true }) {
  const [infoBenevole, setInfoBenevole] = useState(false);
  // En Pro, pas de barre
  if (isPro) return null;

  const pct = Math.min((totalBillets / STARTER_LIMIT) * 100, 100);
  const restants = Math.max(STARTER_LIMIT - totalBillets, 0);
  const isWarning = totalBillets >= 80 && totalBillets < STARTER_LIMIT;
  const isFull = totalBillets >= STARTER_LIMIT;

  // Couleur de la barre selon le remplissage
  const barColor = isFull
    ? "#e53935"
    : isWarning
    ? "#ff8f00"
    : "#2e7d32";

  return (
    <div style={{ ...s.wrapper, ...(isFull ? s.wrapperFull : isWarning ? s.wrapperWarning : s.wrapperNormal) }}>
      {/* Ligne du haut : compteur + bouton upgrade */}
      <div style={s.topRow}>
        <div style={s.label}>
          <span style={{ ...s.count, color: barColor }}>
            {totalBillets}/{STARTER_LIMIT}
          </span>
          <span style={s.labelText}>
            {isFull
              ? " — Limite atteinte !"
              : isWarning
              ? ` — Plus que ${restants} billets`
              : ` billets vendus`}
          </span>
        </div>
        <button
          onClick={peutPayer ? onUpgrade : () => setInfoBenevole((v) => !v)}
          disabled={loadingPaiement}
          style={{ ...s.btnUpgrade, ...(isFull ? s.btnUpgradeFull : {}) }}
        >
          {loadingPaiement ? "…" : "⭐ Passer en Pro"}
        </button>
      </div>

      {/* Barre de progression */}
      <div style={s.barBg}>
        <div style={{ ...s.barFill, width: `${pct}%`, background: barColor }} />
      </div>

      {/* Bénévole : seul le responsable peut payer */}
      {!peutPayer && infoBenevole && (
        <div style={s.infoBenevole}>
          👑 Seul le responsable de la tombola peut passer en Pro (29 €, billets illimités).
          Prévenez-le : il le fait en un clic depuis l'onglet <strong>Paramètres</strong>.
        </div>
      )}

      {/* Message si plein */}
      {isFull && (
        <div style={s.fullMsg}>
          {peutPayer
            ? "🔒 Ventes bloquées : passez en Pro pour continuer avec des billets illimités (29 €)."
            : "🔒 Ventes bloquées : prévenez le responsable de la tombola pour passer en Pro."}
        </div>
      )}
    </div>
  );
}

const s = {
  wrapper: {
    borderRadius: "12px",
    padding: "0.85rem 1rem",
    marginBottom: "1rem",
    border: "1.5px solid",
  },
  wrapperNormal: {
    background: "#f7f8fc",
    borderColor: "#e0e0e0",
  },
  wrapperWarning: {
    background: "#fff8e1",
    borderColor: "#ffe082",
  },
  wrapperFull: {
    background: "#ffebee",
    borderColor: "#ffcdd2",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
    gap: "8px",
    flexWrap: "wrap",
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  count: {
    fontWeight: "900",
    fontSize: "1rem",
  },
  labelText: {
    fontSize: "0.85rem",
    color: "#555",
    fontWeight: "600",
  },
  btnUpgrade: {
    padding: "5px 14px",
    background: "linear-gradient(135deg,#ffc107,#ff8f00)",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    fontWeight: "700",
    cursor: "pointer",
    fontSize: "0.82rem",
    whiteSpace: "nowrap",
    boxShadow: "0 2px 8px rgba(255,143,0,0.3)",
  },
  btnUpgradeFull: {
    background: "linear-gradient(135deg,#e53935,#c62828)",
    animation: "pulse 1.5s ease-in-out infinite",
    boxShadow: "0 2px 12px rgba(229,57,53,0.4)",
  },
  barBg: {
    height: "8px",
    background: "#e0e0e0",
    borderRadius: "4px",
    overflow: "hidden",
  },
  barFill: {
    height: "100%",
    borderRadius: "4px",
    transition: "width 0.5s ease, background 0.3s ease",
  },
  infoBenevole: {
    marginTop: "8px",
    fontSize: "0.82rem",
    color: "#4c5ee8",
    background: "#eef0ff",
    borderRadius: "8px",
    padding: "8px 10px",
    lineHeight: 1.5,
  },
  fullMsg: {
    marginTop: "8px",
    fontSize: "0.82rem",
    color: "#c62828",
    fontWeight: "600",
    lineHeight: 1.5,
  },
};
